import type { WhatsAppAPIConstructorArguments } from "../types";

/**
 * A Web quick setup for the WhatsAppAPI
 *
 * @remarks
 * This method will return the same object as the one passed in,
 * as it assumes that fetch and crypto.subtle are available globally
 *
 * @param settings - The WhatsAppAPI arguments
 * @returns A WhatsAppAPI arguments object for the Web
 */
export function Web(
    settings: WhatsAppAPIConstructorArguments
): WhatsAppAPIConstructorArguments {
    return settings;
}
